import labels from "../json/InputsMetadata.json";

const {
  fields: { effort, trip },
} = labels;

export function getFieldLabel(level, field, key = "label", lang = "en") {
  if (typeof level === "string" && level.length === 0) {
    return "";
  }
  if (typeof field === "string" && field.length === 0) {
    return "";
  }
  let dataObj = {};
  // Getting field data
  if (level === "trip") {
    dataObj = trip.find((item) => field in item);
  } else if (level === "effort") {
    dataObj = effort.find((item) => field in item);
  }
  // accessing object properties
  const {
    label: {
      0: { en: label_en },
    },
    helptext: {
      0: { en: helptext_en },
    },
  } = dataObj[field];
  let stringToReturn = "";
  //
  if (lang === "en") {
    switch (key) {
      case "label":
        stringToReturn = label_en;
        break;
      case "helptext":
        stringToReturn = helptext_en;
        break;
      default:
      //
    }
  }
  return stringToReturn;
}

export function getErrorText(level, field, type, lang = "en") {
  if (typeof level === "string" && level.length === 0) {
    return "";
  }
  if (typeof field === "string" && field.length === 0) {
    return "";
  }
  if (typeof type === "string" && type.length === 0) {
    return "";
  }

  const dataObj =
    level === "trip"
      ? trip.find((item) => field in item)
      : effort.find((item) => field in item);
  const { error_text: errorTextObj } = dataObj[field];
  const errorMsg = errorTextObj.find((item) => type in item);

  return errorMsg ? errorMsg[type][lang] : "";
}
